export default class AccessInfo {
  constructor(el) {
    this.el = el
    this.tabs = [...this.el.querySelectorAll('.access-info--tab[data-tab]')]
    this.panels = [...this.el.querySelectorAll('.access-info--panel')]
    this.init()
  }

  init() {
    this.initTabs()
  }

  initTabs() {
    if (!this.tabs.length) return

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tab

        this.tabs.forEach(t => t.classList.remove('is-active'))
        tab.classList.add('is-active')

        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === index)
        })
      })
    })
  }
}
